import { render, staticRenderFns } from "./AdminHomeView.vue?vue&type=template&id=5650c42c&"
import script from "./AdminHomeView.vue?vue&type=script&lang=ts&"
export * from "./AdminHomeView.vue?vue&type=script&lang=ts&"
import style0 from "./AdminHomeView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports